<!-- 由于需要复用  这里重新封装一遍 -->
<template>
  <div class='r-c-bottom' v-if='detailInfo && detailInfo.carrier' :key='Math.random()'>
    <template
      v-if="deviceHash['sensor'].length || deviceHash['gateway'].length || deviceHash['display'].length || deviceHash['relay'].length">
      <table class='border-theme tb uk-margin-small-bottom'>
        <template v-if='extInfo'>
          <tr v-if='extInfo.speed'>
            <td style='width:100px'>{{ $t('integration.time') }}</td>
            <td>{{ $timetransition(extInfo.time) }}</td>
          </tr>

          <tr>

            <tr v-if='extInfo.time'>
              <td style='width:100px'>{{ $t('integration.speed') }}</td>
              <td>{{ extInfo.speed }} km/h</td>
            </tr>
          </tr>
        </template>
        <tr>
          <td style='width:100px'>{{ $t('integration.abnormal') }}</td>
          <td>
            <i v-icon:theme="['isMapAbnormalConvert', detailInfo.carrier.abnormal]"></i>
          </td>
        </tr>

      </table>

      <table class='tb border-theme uk-margin-small-bottom' v-if='sampleVal.length'>
        <tr>
          <td colspan='3'
              :title="$t('integration.sampling_is_used_to_represent_an_overall_value_of_the_monitoring_point_within_the_monitoring_range')">
            {{ $t('integration.sampling') }}
          </td>
        </tr>

        <!-- 取样 -->
        <template v-for='(item, index) in sampleVal'>
          <!-- 检测区间 -->
          <tr class='line-theme'>
            <td colspan='3' v-if='item.isRange'>
              <span v-if="item.code === 'temp'">{{ $t('integration.unrelated_temperature_range') }}</span>
              <span v-else-if="item.code === 'hum'">{{ $t('integration.unrelated_humidity_range') }}</span>
            </td>
            <!-- 有监测区间的情况 -->
            <td colspan='3' v-else>{{ item.rangeName }}{{ `(${formatTempValue(item.min,unit[item.code].name)}${unit[item.code].name} ~
                                                    ${formatTempValue(item.max,unit[item.code].name)}${unit[item.code].name})` }}
            </td>
          </tr>

          <tr>
            <td style='width:30px'>
              <el-popover trigger='hover'>
                <SampleValue :sampleValue='{ [item.code]: [item] }' style='width:300px'
                             :typeId='detailInfo.carrier.typeId' :carrier-info='detailInfo'
                             :carrierName='detailInfo.carrier.keycode' :carrierId='detailInfo.carrier.id'
                             :scopeName='scopeName'></SampleValue>
                <template #reference>
                  <i class='el-icon-info'></i>
                </template>
              </el-popover>
            </td>
            <td>{{ $timetransition(item.time) }}</td>
            <td v-range="[item.val, item, 'background']" style='width:60px;'>{{ item.val }}{{ item.val ?
              unit[item.code].name : '---' }}
            </td>
          </tr>
          <!-- <tr v-for="(sensor, index) in item.itemMap">
          <td style="width:30px"><i class="el-icon-info"></i></td>
          <td>{{ $timetransition(sensor.time) }}</td>
          <td v-range="[sensor.val, item, 'background']" style="width:60px;">{{ sensor.val }}{{ unit(sensor.code) }}</td>
      </tr> -->
        </template>
      </table>

      <!-- 传感器 -->
      <table class='tb border-theme uk-margin-small-bottom' v-if='deviceHash.sensor.length'>
        <tr>
          <td colspan='5'>{{ $t('integration.sensor') }}</td>
        </tr>

        <!-- 传感器 -->
        <template v-for='item in sensorProbe'>
          <tr v-if='!item.isRange' class='line-theme'>
            <td colspan='5'>
              {{ `${item.min}${unit[item.code].name} ~ ${item.max}${unit[item.code].name}`
              }}
            </td>
          </tr>
          <tr class='line-theme' v-else>
            <td colspan='5'>
              <span v-if="item.code === 'temp'">{{ $t('integration.unrelated_temperature_range') }}</span>
              <span v-else-if="item.code === 'hum'">{{ $t('integration.unrelated_humidity_range') }}</span>
            </td>
          </tr>
          <template v-for='sensor in item.sensorProbeList'>

            <!-- 温度取样值 -->
            <tr>
              <td style='width:20px;'><i
                :class='equiIconConvert(sensor.carrier_device_catalog, sensor.sensorType).icon'
                :title='$t(equiIconConvert(sensor.carrier_device_catalog, sensor.sensorType).title)'
                class='cursor-pointer mr-5 ml-5'></i></td>
              <td style='width:20px'><i v-icon="['equiStatusConvert', sensor.sensor_status]"
                                        style='margin-left: 5px;'></i></td>
              <td>{{ sensor.carrierDeviceName }}</td>

              <td colspan='2' v-range="[sensor.probe && sensor.probe['temp'].val, item, 'background']"
                  style='width: 60px;'>
                {{ `${(sensor.probe && sensor.probe[item.code] && sensor.probe[item.code].val) ||
              '---'}${unit[item.code].name}` }}
              </td>
            </tr>

            <!-- 时间 -->
            <tr v-if="sensor.probe && (sensor.probe['temp'] || sensor.probe['hum'])">
              <td colspan='3'>
                {{ $timetransition(sensor.probe['temp'] ? sensor.probe['temp'].time :
                sensor.probe['hum'].time) }}
              </td>
              <td style='width:30px'>
                                <span><i class='el-icon-document cursor-pointer' @click='probeDetail(sensor)'
                                         :title="$t('integration.details')"></i></span>
              </td>
              <td style='width:30px'>
                                <span><i class='iconfont icon-zhexiantu cursor-pointer' @click='historyData(sensor)'
                                         :title="$t('integration.data_board')"></i></span>
              </td>
            </tr>
          </template>
        </template>
      </table>

      <!-- 网关 -->
      <table class='tb border-theme uk-margin-small-bottom' v-if='gatewayList.length'>
        <tr>
          <td colspan='4'>{{ $t('integration.gateway') }}</td>
        </tr>

        <template v-for='gateway in gatewayList'>
          <tr>
            <td style='width:20px;'><i v-icon="['gatewayTypeConvert', gateway.device_type]"
                                       style='margin-left: 5px;'></i></td>
            <td style='width:20px'><i v-icon="['equiStatusConvert', gateway.device_status]"
                                      style='margin-left: 5px;'></i></td>
            <td>{{ gateway.carrierDeviceName }}</td>
            <td><i class='el-icon-document cursor-pointer' :title="$t('integration.details')"
                   @click='probeDetail(gateway)'></i></td>
          </tr>
        </template>
      </table>

      <!-- 显示屏 -->
      <table class='tb border-theme uk-margin-small-bottom' v-if='displayList.length'>
        <tr>
          <td colspan='4'>{{ $t('integration.display') }}</td>
        </tr>

        <template v-for='display in displayList'>
          <tr>
            <td style='width:20px;'><i v-icon="['displayTypeConvert', display.device_type]"
                                       style='margin-left: 5px;'></i></td>
            <td style='width:20px'><i v-icon="['equiStatusConvert', display.device_status]"
                                      style='margin-left: 5px;'></i></td>
            <td>{{ display.carrierDeviceName }}</td>
            <td><i class='el-icon-document cursor-pointer' :title="$t('integration.details')"
                   @click='probeDetail(display)'></i></td>
          </tr>
        </template>
      </table>

      <!-- 中继 -->
      <table class='tb border-theme uk-margin-small-bottom' v-if='relayList.length'>
        <tr>
          <td colspan='4'>{{ $t('integration.relay') }}</td>
        </tr>

        <template v-for='relay in relayList'>
          <tr>
            <td style='width:20px;'><i v-icon="['relayTypeConvert', relay.device_type]"
                                       style='margin-left: 5px;'></i></td>
            <td style='width:20px'><i v-icon="['equiStatusConvert', relay.device_status]"
                                      style='margin-left: 5px;'></i></td>
            <td>{{ relay.carrierDeviceName }}</td>
            <td><i class='el-icon-document cursor-pointer' :title="$t('integration.details')"
                   @click='probeDetail(relay)'></i></td>
          </tr>
        </template>
      </table>

      <!-- 底座 -->

      <table class='tb border-theme uk-margin-small-bottom' v-if='relayList.length'>
        <tr>
          <td colspan='4'>{{ $t('integration.base') }}</td>
        </tr>

        <template v-for='base in baseList'>
          <tr>
            <td style='width:20px;'><i v-icon="['relayTypeConvert', base.device_type]"
                                       style='margin-left: 5px;'></i></td>
            <td style='width:20px'><i v-icon="['equiStatusConvert', base.device_status]"
                                      style='margin-left: 5px;'></i></td>
            <td>{{ base.carrierDeviceName }}</td>
            <td><i class='el-icon-document cursor-pointer' :title="$t('integration.details')"
                   @click='probeDetail(base)'></i></td>
          </tr>
        </template>
      </table>
      <!-- 监测点图表按钮 -->
      <div>
        <el-button @click='toCarrierChart' class='w-100' type='primary'>{{ $t('integration.monitoring_point_chart') }}
        </el-button>
      </div>
    </template>

    <!-- 都为空 也就是未关联设备 -->
    <div v-else>
      <el-empty :description="$t('integration.unassociated_device')"></el-empty>
    </div>

  </div>
</template>

<script>
import { carrierProbeHistory, probeHistory } from '@/utils/winDetail'
import Popover from '@/components/SampleValue/SampleValue.vue'
import { carrierStatusConvert, equiIconConvert } from '@/utils/convert'
import bus from '@/utils/bus'
import SamplePopover from '@/pages/home/component/Map/component/SamplePopover'
import SampleValue from '@/components/SampleValue/SampleValue'

export default {
  props: {
    detailInfo: {},
    extInfo: {},
    fullPath: {}

  },
  data () {
    return {
      // 前端手动区分设备
      deviceHash: {
        sensor: [],
        gateway: [],
        display: [],
        relay: [],
        base: []
      }
    }
  },
  watch: {
    detailInfo: {
      immediate: true,
      handler () {
        if (this.detailInfo.carrier && typeof this.detailInfo.carrier.sampleValue === 'string') {
          this.detailInfo.carrier.sampleValue = JSON.parse(this.detailInfo.carrier.sampleValue)
        }

        this.deviceHash = {
          sensor: [],
          gateway: [],
          display: [],
          relay: [],
          base: []
        }

        if (!this.detailInfo.carrier) {
          return
        }
        const {
          isRangeList,
          noRangeList,
          deviceList
        } = this.detailInfo.carrier.carrierDevice
        // 对能绑定区间设备进行区分
        if (isRangeList) {
          this.detailInfo.carrier.carrierDevice.isRangeList.forEach(item => {
            // 遍历探测列表  因为里面包含底座和传感器 需要各自进行区分
            for (let i = 0; i < item.sensorProbeList.length; i++) {
              switch (item.sensorProbeList[i].carrier_device_catalog) {
                // 传感器
                case 0:
                  this.deviceHash.sensor.push(item.sensorProbeList[i])
                  break
                // 底座
                case 4:
                  this.deviceHash.base.push(item.sensorProbeList[i])
                  break
              }
            }
          })
        }
        if (noRangeList) {
          // 对不能绑定区间的设备进行区分
          this.detailInfo.carrier.carrierDevice.noRangeList.forEach(item => {
            switch (item.deviceCatalog) {
              // 网关
              case 1:
                this.deviceHash.gateway.push(item)
                break
              // 显示屏
              case 2:
                this.deviceHash.display.push(item)
                break
              // 中继
              case 3:
                this.deviceHash.relay.push(item)
                break
            }
          })
        }
      }
    }
  },
  components: {
    Popover,
    SamplePopover,
    SampleValue
  },
  computed: {
    equiIconConvert: () => equiIconConvert,
    gatewayList () {
      return this.deviceHash.gateway
    },
    displayList () {
      return this.deviceHash.display
    },
    relayList () {
      return this.deviceHash.relay
    },
    baseList () {
      return this.deviceHash.base
    },
    carrierStatusConvert: () => carrierStatusConvert,
    sampleVal () {
      if (!this.detailInfo.carrier) return false

      if (typeof this.detailInfo.carrier.sampleValue === 'string') {
        this.detailInfo.carrier.sampleValue = JSON.parse(this.detailInfo.carrier.sampleValue)
      }
      const sample = this.detailInfo.carrier.sampleValue
      if (!sample) {
        return []
      }

      let result = []
      if (sample.temp) {
        result = result.concat(
          sample.temp.map(item => {
            item.code = 'temp'
            return item
          })
        )
      }

      if (sample.hum) {
        result = result.concat(
          sample.hum.map(item => {
            item.code = 'hum'
            return item
          })
        )
      }

      return result
    },
    sensorProbe () {
      //   if (!this.detailInfo.sensor) return false
      return this.detailInfo.carrier.carrierDevice.isRangeList.map(sensor => {
        sensor.sensorProbeList.map(item => {
          if (typeof item.probe === 'string') item.probe = JSON.parse(item.probe)
          return item
        })

        return sensor
      })
    },
    scopeName () {
      const carrier = this.detailInfo.carrier
      if (carrier) {
        if (carrier.fullPath || this.fullPath) {
          return (carrier.fullPath || this.fullPath).split('/')[0]
        } else {
          return carrier.scopeName || ''
        }
      }
    }
  },
  methods: {
    formatTempValue(val,code) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'

      const result = TempUtils.convertToCelsius(numVal, code);
      return `${result}`
    },
    historyData (item) {
      const {
        tag,
        keycode,
        id,
        typeId,
        fullPath
      } = (this.detailInfo.carrier)
      //   sensorHistory(item.id, item.tag, '', this.scopeName, keycode,id,typeId)
      probeHistory(id, keycode, typeId, item.carrierDeviceCode, item.carrierDeviceName, item.sensorType)
    },
    // unit (code) {
    //   return code === 'temp' ? '°C' : '%'
    // },
    probeDetail (probe) {
      const {
        scene_id,
        id,
        typeId
      } = this.detailInfo.carrier
      bus.$emit('probeParam', {
        sceneId: scene_id,
        carrierId: id,
        probeCode: probe.carrierDeviceCode,
        carrierType: typeId
      })
    },

    toCarrierChart () {
      const {
        keycode,
        id,
        typeId,
        description
      } = this.detailInfo.carrier
      carrierProbeHistory({
        carrierId: id,
        type: typeId,
        description,
        carrierName: keycode,
        carrierInfo: this.detailInfo.carrier
      })
    }
  }

}
</script>

<style scoped lang='scss'>
.r-c-bottom {
  width: 100%;
  height: calc(100% - 300px);
  padding: 5px;
  box-sizing: border-box;

  .content-collapse {
    height: calc(100% - 30px);
    padding: 15px 0;
    box-sizing: border-box;
    overflow: auto;
  }

  .temp-class,
  .hum-class {
    height: 30px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .t-h-time {
      white-space: nowrap;
      line-height: 30px;
      flex: 3;
      text-align: center;
      background-color: var(--primary-color);
      color: #ffffff;
      border-radius: 2px;
      font-size: 12px;
      border: 1px solid var(--primary-color);
      border-right: none;
      border-radius: 2px 0px 0px 2px;
    }

    .t-h-val {
      flex: 1;
      line-height: 30px;
      font-size: 12px;
      text-align: center;
      border: 1px solid var(--primary-color);
      border-left: none;
      border-radius: 2px 0px 0px 2px;
    }

    .icon {
      width: 30px;
      border: 1px solid var(--primary-color);
      border-left: none;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      border-radius: 2px 0px 0px 2px;
    }
  }

  .hum-class {
    margin-top: 5px;
  }

  .border-1 {
    border: 1px solid var(--primary-color);
  }

  .active-header {
    height: 30px;
    line-height: 30px;
    text-align: center;

    background-color: var(--primary-color);
    color: #ffffff;

    .fb {
      font-weight: bold;
    }
  }

  .sensor-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    border-bottom: 1px solid var(--primary-color);
    border-top: 1px solid var(--primary-color);
  }

  .s-c-content {
    flex: 1;
    text-align: center;
  }

  .s-c-right {
    width: 60px;
    height: 30px;

    display: flex;
    justify-content: space-around;

    .s-c-right-icon {
      line-height: 30px;
      flex: 1;
      text-align: center;
      border-left: 1px solid var(--primary-color);

      &:last-child {
        cursor: pointer;

        &:hover {
          color: red;
        }
      }
    }
  }

  // 探测值
  .bottom-content {

    .b-c-val,
    .b-c-time {
      line-height: 30px;
      text-align: center;
      border-bottom: 1px solid var(--primary-color);
    }

    .b-c-time {
      border-bottom: none;
    }
  }

  // 网关 显示屏 中继
  .public-device {
    height: 30px;
    display: flex;
    padding: 0 10px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--primary-color);
    margin-bottom: 10px;
  }
}

table {
  tr > td:nth-child(1) {
    padding-left: 0;
    padding-right: 0;
    white-space: nowrap;
  }
}

.border-theme {
  border: solid 1px var(--primary-color);
}

.tb {
  width: 100%;

  td {
    padding: 5px 3px;
    text-align: center;
    border-bottom: solid 1px var(--primary-color);
    border-right: solid 1px var(--primary-color);
  }

  .line-theme {
    background-color: var(--primary-color);
    color: white;
  }
}
</style>
